import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import auth from '../../../../../config/auth';
import { axiosInstance } from '../../../../../config/axios';

export interface State {
  searchPortFacilities: SearchPortFacilities;
}

export interface PortFacility {
  unlocode: string;
  facilityName: string;
  gisisCode: string;
  imoPortFacilityNumber: string;
}

interface SearchPortFacilities {
  searchResults: { [key: string]: PortFacility };
  loading: { [key: string]: boolean };
}

const initialState: SearchPortFacilities = {
  searchResults: {},
  loading: {},
};

export const getPortFacilitiesFromApi = async ({
  portUnlocode,
}: {
  portUnlocode: string;
}) => {
  const headers = auth.getHeaders();
  const endpoint = `/ports/${portUnlocode}/port-facilities`;
  const response = await axiosInstance.get(endpoint, { headers });

  return response.data.data;
};

export const searchPortFacilities = createAsyncThunk<
  {
    dropdownID: string;
    data: PortFacility;
  },
  {
    dropdownID: string;
    portUnlocode: string;
  }
>('port/searchPortFacilities', async ({ dropdownID, portUnlocode }) => {
  const headers = auth.getHeaders();
  const endpoint = `/ports/${portUnlocode}/port-facilities`;
  const response = await axiosInstance.get(endpoint, { headers });

  return {
    dropdownID,
    data: response.data.data,
  };
});

export const searchPortFacilitiesSlice = createSlice({
  name: 'searchPortFacilities',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchPortFacilities.pending, (state, { meta }) => {
        const { dropdownID } = meta.arg;
        state.loading[dropdownID] = true;
      })
      .addCase(searchPortFacilities.fulfilled, (state, action) => {
        const { dropdownID, data } = action.payload;
        state.searchResults[dropdownID] = data;
        state.loading[dropdownID] = false;
      })
      .addCase(searchPortFacilities.rejected, (state, { meta }) => {
        const { dropdownID } = meta.arg;
        state.loading[dropdownID] = false;
      });
  },
});

export const {} = searchPortFacilitiesSlice.actions;

export const selectSearchPortFacilitiesResults = (
  state: State,
  dropdownId: string
) => state.searchPortFacilities.searchResults[dropdownId];
export const selectSearchPortFacilitiesLoadingState = (
  state: State,
  dropdownId: string
) => state.searchPortFacilities.loading[dropdownId];

export default searchPortFacilitiesSlice.reducer;
